import { render, staticRenderFns } from "./badgePush.vue?vue&type=template&id=43b446a0&scoped=true&"
import script from "./badgePush.vue?vue&type=script&lang=js&"
export * from "./badgePush.vue?vue&type=script&lang=js&"
import style0 from "./badgePush.vue?vue&type=style&index=0&id=43b446a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b446a0",
  null
  
)

export default component.exports